import React from 'react';
import styled from 'styled-components';
import { StyledButtonContainer } from './ButtonContainer';
import Refresh from './Refresh';

const ErrorButtonContainer = styled(StyledButtonContainer)`
  margin-top: 50px;

  .refreshButton {
    margin-top: 30px;
    float: initial;
    text-align: center;
  }
`;

const ErrorContainer = ({ children }) =>{
  return (<ErrorButtonContainer>
    {children}
    <Refresh />
  </ErrorButtonContainer>);
};

export default ErrorContainer;
